if(typeof FN == 'undefined') FN = {};


FN.topBar = {
  active: false,
  visible: false,
  topThreshold: 0,
  selectors: {
    baseElementClass: 'top-bar',
    topThresholdElement: '.text-with-media:last-of-type'
  },

  init: function(){
    FN.topBar.active = true;
    FN.topBar.resetTopThreshold();

    window.addEventListener('resize', function(){
      FN.topBar.resetTopThreshold();
    });

    window.addEventListener('scroll', function() {
      var scrollingPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
      FN.topBar.toggle(scrollingPosition > FN.topBar.topThreshold);
    });
  },

  resetTopThreshold: function(){
    var thresholdElement = document.querySelector(FN.topBar.selectors.topThresholdElement);
    if(!thresholdElement) return;
    FN.topBar.topThreshold = thresholdElement.getBoundingClientRect().top + window.pageYOffset;
  },

  toggle: function(show){
    if(FN.topBar.active === false){ return; }
    if(show === FN.topBar.visible){ return; }
    var newTopBarPos = (show) ? '0px' : '-10em';
    document.querySelectorAll('.' + FN.topBar.selectors.baseElementClass).forEach(function(el) {
      el.style.top = newTopBarPos;
    });
    FN.topBar.visible = show;
  }
};
